import React from "react"
import Plesk from "../../../static/img/vendor/plesk.webp"

const FeaturesWordPressPlesk = () => {
  return (
    <section className="money-back-block">
      <div className="container-xl">
        <div className="row">
          <div className="col-12 col-lg-6">
            <div className="d-flex justify-content-center d-none d-lg-block  p-5">
              <img
                className="img-fluid"
                alt="Plesk Control Panel"
                src={Plesk}
              />
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="d-flex flex-column justify-content-center">
              <h3 className="mb-4 component-title text-dark-blue">
                Comprehensive Web Hosting Control Panel
              </h3>
              <div className="description py-4">
                Plesk is the OS-agnostic server control panel that offers one
                tool to install, manage, update, and secure sites and online
                applications. Plesk benefits businesses with the flexibility to
                mass-manage projects with a single click, add extra features,
                and maximize ROI to scale. Plesk is specifically designed for
                developers, IT admins, content managers, infrastructure
                providers, and digital agencies.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FeaturesWordPressPlesk
